import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import{ PageDefault }from '../pages/PageDefault';


@Injectable()
export class LotteryOpenService {

    constructor(
        private httpService: HttpService) { }

    //获取各种彩种最新的开奖号码
    //TQQ 2016-12-26
    getLotteryOpenLatest() {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLotteryOpenLatest";
        return this.httpService.get(url);
    }

    //获取彩种的开奖号码
    //TQQ 2016-12-27
    getLotteryOpen(lotteryCode: string, pageIndex: number=PageDefault.PageIndex(), pageSize: number=PageDefault.PageSize()) {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLotteryOpen?lotteryCode=" + lotteryCode + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize;
        return this.httpService.get(url);
    }

    /** 走势图数据 */
    trendData(param: TrendData) {
      var url = AppConfig.GetProdUrl() + "/Lottery/TrendData?lotteryId=" + param.lotteryId + '&command=' + param.command;
      return this.httpService.post(url,{});
  }
}

export class TrendData {
  lotteryId: string;
  command: string
}






// WEBPACK FOOTER //
// ./src/services/lotteryopen.service.ts